<template>
  <im-right-list-layout>
    <template v-slot:sidebar-operation>
      <conversation-search />
    </template>
    <template v-slot:sidebar-content>
      <div class="conversation-warp" v-show="imLeftActiveName === 'chat'">
        <conversation-item :session="bot" :is-active="activeAccount.id === bot.id"  @active-change="handleActiveChange" />
        <conversation-item
          v-for="(item, index) in imSessions"
          :key="index"
          :session="item"
          :is-active="activeAccount.id === item.id"
          @active-change="handleActiveChange"
        />
      </div>
      <contacts v-show="imLeftActiveName === 'mailList'" />
    </template>
  </im-right-list-layout>
</template>

<script>
import ConversationSearch from './ConversationSearch'
import ConversationItem from './ConversationItem'
import ImRightListLayout from './ImRightListLayout'
import Contacts from './contacts/Contacts'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ImRightList',
  components: { ConversationItem, ConversationSearch, ImRightListLayout, Contacts },
  computed: {
    ...mapState({
      imAccount: state => state.imAccount,
      imLeftActiveName: state => state.imLeftActiveName,
      imSessions: state => state.imSessions,
      activeAccount: state => state.imActiveAccount,
      imSessionMsgs: state => state.imSessionMsgs
    })
  },
  data () {
    return {
      bot: {
        id: '7380252502656237619',
        scene: 'bot',
        icon: 'https://cdn.pixabay.com/photo/2020/08/19/00/13/sea-5499649_1280.jpg',
        to: '7380252502656237619',
        nick: '小浪',
        lastMsg: { text: '你好，我是小浪！', time: 1719392086887 }
      }
    }
  },
  methods: {
    ...mapActions(['resetCurrSession', 'imActiveChange', 'sendCustomSysMsg']),
    handelBeforeClick (session) {
      this.resetCurrSession(session)
    },
    handleActiveChange (session) {
      console.log('handleActiveChange', session)
      this.$store.dispatch('changeImActiveAccountAction', session)
      this.imActiveChange({ session: session, scene: this.activeAccount.scene, to: this.activeAccount.to, messageListScrollTot: 'bottom', imAccId: this.imAccount.im_accid })
      if (session.scene === 'p2p' && session.to !== '7380252502656237619' && session.unread !== 0) {
        let content = {
          type: 'sycMsgReceiptsNotify',
          sessionId: session.id
        }
        this.sendCustomSysMsg(content)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.conversation-warp {
  height: 90%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/ImRightList.vue